import Head from "next/head";
import React, { useEffect } from "react";
import AlbumSection from "shared/components-pages/propiedad/AlbumSection";
import DetailsSection from "shared/components-pages/propiedad/DetailsSection";
import LoanCalculatorDetails from "shared/components-pages/propiedad/LoanCalculatorDetails";
import PropertiesSlider from "shared/components-pages/proyectos/PropertiesSlider";
import LoadingBubbles from "shared/components/loading-bubbles";
import { GetServerSideProps } from "next";
import { getRealestateDetails, getRealestateLog } from "api/realestate.request";
import { CPagesPath } from "shared/models/const/pages-path";
import { useTranslations } from "next-intl";
import { isNumber, isString } from "lodash";

import type { NextPage } from "next";
import { usePropertyDetail } from "store/property-detail";
import Banners from "@components/news/baners";
import { RoomPreferencesSharp } from "@mui/icons-material";
import createCanonicalUrl from "@helpers/removeparams";
import { DetailPropertyProvider } from "@components-pages/propiedad/context/DetailPropertyContext";
import { query } from "express";
const fetchDetails = (
  id: number,
  filters: {
    withAgencyReferer?: number | null | undefined;
    withAgentReferer?: number | null | undefined;
  }
) => {
  return getRealestateDetails(id, filters);
};

const Propiedad: NextPage = (props: any) => {
  const translation = useTranslations("property");
  const similarProperties = translation("similarProperties") || "";
  const [title, ...rest] = similarProperties.split(" ");
  const { setDetailPropertyAction } = usePropertyDetail();
  const data = props?.data?.data;

  useEffect(() => {
    if (props?.data?.data != undefined) {
      // if (props?.reload){
      //   window.location.replace(props?.url?.replaceAll("&mobile=true", "")) ;

      // }
      setDetailPropertyAction(data);
    }
  }, [data]);

  useEffect(() => {
    if (props.id) {
      setTimeout(() => {
        getRealestateLog(props.id);
      }, 1000);
    }
  }, []);

  if (props?.data == undefined || props?.data?.data == undefined) {
    return <LoadingBubbles message="Cargando" />;
  }

  const metaData = {
    title: (data.realstate_type + " " + data.sector + "-" + props.id).substr(
      0,
      60
    ),
    description: `${
      data.description
        ? data.description.replace(/(<([^>]+)>)/gi, "").substr(0, 150)
        : typeof data?.slug == "number"
        ? data?.slug
        : data?.slug?.replaceAll("-", " ")
    } ${data.id}`,
    url: props.url,
    realstateType: data.realstate_type,
    picture: data.pictures[0].pictures,
  };
  return (
    <>
      <Head>
        <title>{metaData.title}</title>
        <meta name="description" content={metaData.description} />
        <meta property="og:url" content={metaData.url} />
        <meta property="og:type" content={metaData.realstateType} />
        <meta property="og:title" content={metaData.title} />
        <meta property="og:description" content={metaData.description} />
        <meta property="og:image" content={metaData.picture} />
        <meta name="robots" content="noindex" />

        <link
          rel="canonical"
          href={createCanonicalUrl(metaData.url)}
          key="canonical"
        />
        <meta name="robots" content="noindex" />
      </Head>
      <DetailPropertyProvider data={data} url={props.url}>
        <Banners />

        <div className="container">
          <AlbumSection data={data} id={props.id} isCollection={false} />
          <DetailsSection data={data} realestateId={props.id} />
        </div>

        <LoanCalculatorDetails data={data!} />

        <PropertiesSlider
          title={title}
          subtitle={rest.join(" ")}
          filters={{ similarCode: data?.id }}
          refRequest="property-list-alike-query"
          detailPath={CPagesPath.es.property_detail}
        />
      </DetailPropertyProvider>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const params = context.params as any;
  const locale = context.locale;
  const splashSlug: string = params.params[1];
  var id = null;

  if (splashSlug && isNumber(splashSlug)) {
    id = splashSlug;
  }

  if (splashSlug && isString(splashSlug)) {
    id = splashSlug.split("-")[splashSlug.split("-").length - 1];
  }

  const data = await fetchDetails(id as any, {
    withAgencyReferer: context?.query?.areferer as any,
    withAgentReferer: context?.query?.referer as any,
  });

  if (!data || data.status == 404 || data.status == 500 || data.status == 410) {
    return {
      redirect: {
        destination: "/propiedades",
        permanent: false,
      },
    };
  }

  await getRealestateLog(id!);

  return {
    props: {
      context: context.query,
      params,
      reload: context?.query?.mobile == "true" ? true : false,
      url: process.env.NEXT_PUBLIC_DOMAIN_URL + context.resolvedUrl,
      data: data,
      id: id,
      messages: (await import(`../../lang/${locale}.json`)).default,
    },
  };
};

export default Propiedad;
